export default {
  CONSUEL: "Visa Consuel (en résidentiel)",
  CONSUEL_LARGE_PRODUCER: "Visa Consuel (en tertiaire)",
  MAYOR: "Autorisation d'urbanisme (en résidentiel)",
  MAYOR_LARGE_PRODUCER: "Autorisation d'urbanisme (en tertiaire)",
  GRID_CONNECTION: "Raccordements (< 36kVa)",
  GRID_CONNECTION_LARGE_PRODUCER: "Raccordements (36-250kVa)",
  GRID_CONNECTION_LARGE_PRODUCER_HTA_250_TO_500_KVA:
    "Raccordements (250-500kVa)",
  GRID_CONNECTION_LARGE_PRODUCER_HTA_ABOVE_500_KVA: "Raccordements (>500kVa)",
}
